<template>
  <div class="popup z-index-10-fg confirmation small-popup add-interaction-popup" ref="popupWindow" @dragenter="$refs.fileUpload.dragging = true">
    <div class="popup-content" ref="popupContent">
      <div class="popup-header">
        <h2>Add an Interaction</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
        <div class="paperclip-icon" @click="$refs.fileUpload.$refs.fileUploadInput.click()">
          <img id="noHover" src="../assets/paperclip.svg" alt="" />
          <img id="hover" src="../assets/paperclip-hover.svg" alt="" />
        </div>
      </div>
      <!-- Complete-lead shortcut disabled; completions should be added through AddCompletion.vue. -->
      <!-- <div :class="{ 'popup-body': true, 'hide-complete': !complete }"> -->
      <div :class="{ 'popup-body': true }">
        <Dropdown :options="interactionTypes" label="Type" v-model="type" class="input-item medium-item" />

        <div class="primary-input input-item medium-item">
          <input type="date" v-model="date" />
          <label>Date</label>
        </div>

        <div class="primary-input input-item large-item">
          <textarea type="text" v-model="note" rows="4" style="resize: none"></textarea>
          <label>Note</label>
        </div>

        <div :class="['primary-input', 'input-item', 'medium-item']" v-if="type == 'Sent Quote'">
          <input type="text" v-model="bwQuote" />
          <label>BW Quote</label>
        </div>
        <!-- <div :class="['primary-input', 'input-item', 'medium-item']" v-if="type == 'Sent Quote' && !complete"> -->
        <div :class="['primary-input', 'input-item', 'medium-item']" v-if="type == 'Sent Quote'">
          <input type="text" v-model="amount" @blur="formatAmount()" />
          <label>Amount</label>
        </div>
        <!-- <div :class="['primary-input', 'input-item', complete ? 'medium-item' : 'large-item']" v-if="type == 'Sent Quote'"> -->
        <div :class="['primary-input', 'input-item', 'large-item']" v-if="type == 'Sent Quote'">
          <input type="text" v-model="jobName" />
          <label>Job Name</label>
        </div>

        <Checkbox label="Delivery" v-model="hasDelivery" v-if="type == 'Sent Quote'" class="input-item large-item" />

        <AddressSearch
          :options="lookupResults"
          label="Site Address"
          v-model="deliveryAddress"
          class="input-item large-item"
          v-if="type == 'Sent Quote' && hasDelivery"
          @autofillAddress="(o) => (deliveryAddress = o.formattedAddress)"
          @clearLookup="lookupResults.length = 0" />

        <div class="primary-input input-item medium-item" v-if="type == 'Sent Quote' && hasDelivery">
          <input type="date" v-model="deliveryDate" />
          <label>Delivery Date</label>
        </div>

        <div :class="['primary-input', 'input-item', 'medium-item']" v-if="type == 'Sent Quote' && hasDelivery">
          <input type="text" v-model="gateCode" />
          <label>Gate Code</label>
        </div>

        <div :class="['primary-input', 'input-item', 'large-item']" v-if="type == 'Sent Quote' && hasDelivery">
          <textarea type="text" v-model="deliveryNotes" rows="4" style="resize: none"></textarea>
          <label>Delivery Notes</label>
        </div>

        <div class="file-list" v-if="fileList.length">
          <div v-for="file in fileList" :key="file">
            <img src="../assets/paperclip-thumbnail.svg" />
            <span>{{ file }}</span>
          </div>
        </div>

        <!-- Complete Lead shortcut disabled. Use AddCompletion.vue after saving the interaction.
        <div class="complete-lead-section">
          <Checkbox label="Complete Lead" v-model="complete" class="input-item small-item" />
          <div :class="['primary-input', 'input-item', 'small-item', showErrors && !validInvNum ? 'invalid' : '']" v-if="complete && type == 'Confirmed Order'">
            <input type="text" v-model="invNum" />
            <label>Invoice Number</label>
          </div>
          <div :class="['primary-input', 'input-item', 'small-item', showErrors && !validAmount ? 'invalid' : '']" v-if="complete && type == 'Confirmed Order'">
            <input type="text" v-model="amount" @blur="formatAmount()" />
            <label>Amount</label>
          </div>
        </div>
        -->

        <FileUpload
          :leadid="leadid"
          :isPanel="true"
          ref="fileUpload"
          @updateFileList="
            (e) => {
              fileList = e;
            }
          " />
      </div>
      <div class="popup-footer">
        <button @click="$emit('closePopup')" class="text-btn">close</button>
        <!-- <button :disabled="isSaving" :class="{ 'square-btn': true, saving: isSaving }" @click="saveInteraction()">{{ completeBtnText }}<img src="../assets/spinner.svg" /></button> -->
        <button :disabled="isSaving" :class="{ 'square-btn': true, saving: isSaving }" @click="saveInteraction()">Save<img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import Dropdown from './inputs/Dropdown.vue';
import Checkbox from './inputs/Checkbox.vue';
import AddressSearch from './inputs/AddressSearch.vue';
import useAlerts from '@/composables/useAlerts';
import useLeadsQuery from '@/composables/useLeadsQuery';
import usePicklistItemsQuery from '@/composables/usePicklistItemsQuery';
import useInteractionMutate from '@/composables/useInteractionMutate';
import useLeadMutate from '@/composables/useLeadMutate';
import { computed } from 'vue';
import useCurrentUser from '@/composables/useCurrentUser';
import useDecryptSymbols from '@/composables/useDecryptSymbols';
import useAddressLookup from '@/composables/useAddressLookup';
import FileUpload from './FileUpload.vue';

export default {
  name: 'Reminder',
  emits: ['closePopup'],
  components: {
    Dropdown,
    Checkbox,
    AddressSearch,
    FileUpload,
  },
  props: {
    leadid: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { addAlert } = useAlerts();
    const { addInteraction } = useInteractionMutate();
    const { updateLead } = useLeadMutate();
    const { user } = useCurrentUser();
    const { encryptSymbols } = useDecryptSymbols();
    const { addressLookup, lookupResults } = useAddressLookup();

    const interactionTypes = computed(() => {
      return usePicklistItemsQuery.pickLists.interactionTypes.items.map((item) => item.NAME);
    });

    return {
      addAlert,
      leads: useLeadsQuery.leadsIncludingSingleLead,
      interactionTypes,
      addInteraction,
      updateLead,
      user,
      encryptSymbols,
      addressLookup,
      lookupResults,
    };
  },
  data() {
    return {
      type: 'Note',
      isSaving: false,
      date: '',
      note: '',
      // complete: false,
      // invNum: '',
      amount: '$',
      bwQuote: '',
      jobName: '',
      deliveryAddress: '',
      // showErrors: false,
      fileList: [],
      hasDelivery: false,
      deliveryDate: '',
      gateCode: '',
      deliveryNotes: '',
    };
  },
  computed: {
    // completeBtnText() {
    //   return this.complete ? 'Save & Complete' : 'Save';
    // },
    // validInvNum() {
    //   if (!this.invNum) return false;
    //   const stripped = String(this.invNum).replace(/[^1-9]/g, '');
    //   return stripped.length > 0 ? true : false;
    // },
    // validAmount() {
    //   if (!this.amount) return false;
    //   const stripped = String(this.amount).replace(/[^1-9]/g, '');
    //   return stripped.length > 0 ? true : false;
    // },
  },
  methods: {
    async saveInteraction() {
      if (!this.verifyFields()) return;
      this.isSaving = true;
      const lead = this.leads.find((lead) => lead.LEADID === this.leadid);
      if (!lead) {
        this.addAlert('Error saving interaction', 'high', 4);
        this.$emit('closePopup');
        return;
      }

      if (new Date() < new Date(this.date)) {
        this.addAlert('Cannot add an interaction in the future', 'high', 4);
        this.isSaving = false;
        return;
      }

      const newInteraction = {
        LEADID: this.leadid,
        NOTE: this.note,
        TYPE: this.type,
        SALESPERSONID: this.user.userid,
        DATE: new Date(this.date).getTime().toString(),
      };

      const currentDate = new Date();
      const currentDateFormated = currentDate.getFullYear() + '-' + (currentDate.getMonth() + 1).toString().padStart(2, '0') + '-' + currentDate.getDate().toString().padStart(2, '0');
      if (this.date == currentDateFormated) {
        newInteraction.DATE = Date.now().toString();
      }

      const updatedLead = {};

      // Complete-lead shortcut disabled. Use AddCompletion.vue after saving the interaction.
      // if (this.complete) {
      //   if (this.type != 'Confirmed Order') {
      //     this.amount = null;
      //     this.invNum = null;
      //   }
      //
      //   updatedLead.COMPLETE = true;
      //   updatedLead.COMPLETEDATE = Date.now().toString();
      //   updatedLead.INVNUM = this.invNum;
      //   updatedLead.AMOUNT = this.amount?.replace(/[^0-9.]/g, '') || null;
      //
      //   lead.COMPLETE = true;
      //   lead.COMPLETEDATE = Date.now();
      //   lead.INVOICENUM = this.invNum;
      //   lead.AMOUNT = this.amount?.replace(/[^0-9.]/g, '') || null;
      // }

      if (this.type == 'Sent Quote') {
        updatedLead.BWQUOTE = this.bwQuote;
        updatedLead.JOBNAME = this.jobName;
        updatedLead.AMOUNT = this.amount?.replace(/[^0-9.]/g, '') || null;

        lead.BWQUOTE = this.bwQuote;
        lead.JOBNAME = this.jobName;
        lead.AMOUNT = this.amount?.replace(/[^0-9.]/g, '') || null;

        if (this.hasDelivery) {
          updatedLead.HASDELIVERY = true;
          updatedLead.DELIVERYADDRESS = this.deliveryAddress;
          updatedLead.DELIVERYDATE = new Date(this.deliveryDate).getTime().toString();
          updatedLead.GATECODE = this.gateCode;
          updatedLead.DELIVERYNOTES = this.deliveryNotes;

          lead.HASDELIVERY = true;
          lead.DELIVERYADDRESS = this.deliveryAddress;
          lead.DELIVERYDATE = (new Date(this.deliveryDate).getTime() + 8 * 60 * 60 * 1000).toString();
          lead.GATECODE = this.gateCode;
          lead.DELIVERYNOTES = this.deliveryNotes;
        } else {
          updatedLead.HASDELIVERY = false;
          updatedLead.DELIVERYADDRESS = null;
          updatedLead.DELIVERYDATE = null;
          updatedLead.GATECODE = null;
          updatedLead.DELIVERYNOTES = null;

          lead.HASDELIVERY = false;
          lead.DELIVERYADDRESS = null;
          lead.DELIVERYDATE = null;
          lead.GATECODE = null;
          lead.DELIVERYNOTES = null;
        }
      }

      if (Object.keys(updatedLead).length) {
        await this.updateLead(this.leadid, updatedLead);
      }

      const newInteractionResponse = await this.addInteraction(this.encryptSymbols(newInteraction));
      if (!newInteractionResponse) {
        this.$emit('closePopup');
        return;
      }

      newInteraction.INTERACTIONID = newInteractionResponse.addInteraction;
      lead.interactions.push({ ...newInteraction, DATE: (new Date(newInteraction.DATE).getTime() + 8 * 60 * 60 * 1000).toString() });

      await this.$refs.fileUpload.uploadFiles(this.leadid, newInteraction.INTERACTIONID);

      this.isSaving = false;
      this.addAlert('Added interaction', 'low', 3);
      this.$emit('closePopup');
    },
    formatAmount() {
      let newAmount = this.amount?.replace(/[^0-9.]/g, '') || '';
      if (newAmount.length == 0) {
        this.amount = '$';
        return;
      }
      newAmount = newAmount.replace(/\.(?=.*\.)/g, '');
      if (newAmount.includes('.') && newAmount.split('.')[1].length == 0) newAmount += '00';
      if (newAmount.includes('.') && newAmount.split('.')[1].length == 1) newAmount += '0';
      if (newAmount.includes('.') && newAmount.split('.')[1].length > 2) {
        newAmount = newAmount.replace(/\./g, '');
        newAmount = newAmount.slice(0, -2) + '.' + newAmount.slice(-2);
      }
      if (newAmount.startsWith('.')) newAmount = '0' + newAmount;
      if (!newAmount.includes('.')) {
        newAmount += '.00';
      }
      if (newAmount == '.00') newAmount = '0.00';
      if (newAmount.match(/^0+(?!\.|$)/)) {
        newAmount = newAmount.replace(/^0+(?!\.|$)/, '');
      }
      newAmount = '$' + newAmount;

      this.amount = newAmount;
    },
    getISODate(date) {
      return date ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}` : null;
    },
    verifyFields() {
      // Complete-lead validation disabled. Confirmed-order completion details belong in AddCompletion.vue.
      // if (this.type == 'Confirmed Order') {
      //   if (!this.validInvNum || !this.validAmount) {
      //     this.showErrors = true;
      //     this.addAlert('Please enter a valid Invoice Number and Amount or select a different type.', 'high', 5);
      //     return false;
      //   }
      // }
      // this.showErrors = false;
      return true;
    },
    calculateWindowDimensions() {
      this.$nextTick(() => {
        const newHeight = this.$refs.popupContent.scrollHeight + 'px';
        this.$refs.popupWindow.style.height = newHeight;
      });
    },
    checkContactAssigned(prevType) {
      const lead = this.leads.find((lead) => lead.LEADID === this.leadid);
      // Complete-lead shortcut disabled. Contact validation now happens in AddCompletion.vue.
      // if (!lead.company && !lead.contact && this.type == 'Confirmed Order') {
      //   this.addAlert('Please assign a contact before completing a confirmed order', 'high', 4);
      //   this.type = prevType;
      //   return false;
      // }
      return true;
    },
  },
  mounted() {
    this.date = this.getISODate(new Date());
    this.calculateWindowDimensions();
  },
  updated() {
    this.$refs.popupWindow.style.transition = 'height 0.5s ease';
    this.calculateWindowDimensions();
  },
  watch: {
    // complete() {
    //   if (!this.complete) {
    //     this.invNum = '';
    //     this.amount = '$';
    //   } else {
    //     if (!this.checkContactAssigned('No Response')) return;
    //     this.type = 'Confirmed Order';
    //   }
    // },
    type(newType, prevType) {
      // if (this.type == 'Confirmed Order') {
      //   if (!this.checkContactAssigned(prevType)) return;
      //   this.complete = true;
      // } else if (this.type == 'Sent Quote') {
      if (this.type == 'Sent Quote') {
        const lead = this.leads.find((lead) => lead.LEADID === this.leadid);
        this.jobName = lead.JOBNAME;
        this.bwQuote = lead.BWQUOTE;
        this.amount = lead.AMOUNT;
        this.formatAmount();
        this.deliveryAddress = lead.DELIVERYADDRESS;
        this.hasDelivery = lead.HASDELIVERY;
        if (lead.DELIVERYDATE) this.deliveryDate = this.getISODate(new Date(parseInt(lead.DELIVERYDATE)));
        this.gateCode = lead.GATECODE;
        this.deliveryNotes = lead.DELIVERYNOTES;
        // this.complete = false;
      }
    },
    deliveryAddress() {
      this.addressLookup(this.deliveryAddress);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-interaction-popup {
  width: 30rem;
  max-height: 90vh;

  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .popup-body {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1.5rem 1rem;

    // .complete-lead-section {
    //   display: flex;
    //   flex-direction: row;
    //   flex-wrap: wrap;
    //   gap: 1.5rem 1rem;
    // }

    .input-item {
      min-width: 20rem;
      flex: 1 0 45%;

      &.small-item {
        min-width: 5rem;
        flex: 1 0 10%;
      }

      &.large-item {
        min-width: 20rem;
        flex: 1 0 90%;
      }

      &.medium-item {
        min-width: 5rem;
        flex: 1 0 25%;
      }
    }
  }
}

// .add-interaction-popup .popup-body.hide-complete {
//   margin-bottom: -2.1rem;
//
//   .complete-lead-section {
//     margin-top: 1.5rem;
//     min-width: 100%;
//   }
// }
</style>
